import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';


@Component({
    selector: 'app-processing',
    templateUrl: './processing.component.html',
    styleUrls: ['./processing.component.scss'],
    standalone: false
})
export class ProcessingComponent implements OnInit {

  constructor(private meta: Meta) { }

  ngOnInit(): void {
    this.meta.addTags([
      { name: 'robots', content: 'noindex, nofollow' }
    ]);
  }
}